import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';

type Value = string;

interface Signature {
  Element: HTMLDivElement;
  Args: {
    value: Value;
    onInit: (value: Value) => void;
    valueMapper: (value: Value) => string;
  };
  Blocks: {
    default: [];
  };
}

export default class extends Component<Signature> {
  @tracked ariaLabel = '';

  get value(): string {
    return this.args.valueMapper(this.args.value);
  }

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args);
    this.args.onInit(this.args.value);
  }

  setAria = modifier((el: HTMLElement): void => {
    this.ariaLabel = el.innerText.trim();
  });

  <template>
    <div
      {{this.setAria}}
      aria-label={{this.ariaLabel}}
      data-value={{this.value}}
      class='item'
      ...attributes
    >
      {{yield}}
    </div>
  </template>
}
